import {
  DELETE_OPERATORS_CATALOG,
  DELETE_OPERATORS_CATALOG_SUCCESS,
  DELETE_OPERATORS_CATALOG_ERROR,
} from '../../../../constants/constantsRed';

export const deleteOperatorsCatalogRed = (state: any = false, actions: any) => {
  switch (actions.type) {
    case DELETE_OPERATORS_CATALOG:
      return {
        ...state,
        loading: true,
      };
    case DELETE_OPERATORS_CATALOG_SUCCESS:
      return {
        data: null,
        loading: false,
        error: null,
      };
    case DELETE_OPERATORS_CATALOG_ERROR:
      return {
        ...state,
        loading: false,
        error: null,
        data: actions.payload,
      };
    default:
      return state;
  }
};
